import { render, staticRenderFns } from "./SuccessShippment.vue?vue&type=template&id=ecb0566c&scoped=true"
import script from "./SuccessShippment.vue?vue&type=script&lang=js"
export * from "./SuccessShippment.vue?vue&type=script&lang=js"
import style0 from "./SuccessShippment.vue?vue&type=style&index=0&id=ecb0566c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb0566c",
  null
  
)

export default component.exports